export default __webpack_public_path__ + "static/media/Automated Last mile shuttles Vienna case study.ef60ba86.pdf";